import { render } from "./NavSidebar.vue?vue&type=template&id=38968360&scoped=true"
import script from "./NavSidebar.vue?vue&type=script&lang=js"
export * from "./NavSidebar.vue?vue&type=script&lang=js"

import "./NavSidebar.vue?vue&type=style&index=0&id=38968360&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38968360"

export default script